import React from "react";
import moment from "moment";
import { getSchedule } from "../../services/schedule";
import "./WebinarTanyaAhli.css";
import { useTranslation } from "react-i18next";

const WebinarTanyaAhliCard = ({
  photo,
  name,
  desc,
  schedule,
  isAvailable,
  handleClick,
  scheduledDay,
  t,
}) => {
  return (
    <div className="wta_card">
      <div className="wtac_head">
        <img className="wtac_photo" src={photo} alt={name} />
        <p className="wtac_name">{name}</p>
        <p style={{ color: "#999999", marginTop: "6px", marginBottom: "10px" }}>
          {desc}
        </p>
        <div className="wtac_schedule">
          <p style={{ color: "#7D61D6", lineHeight: "14px" }}>
            {scheduledDay}
            <br />
            {schedule}
          </p>
        </div>
      </div>
      <div className={`wtac_btn ${!isAvailable ? "disabled" : ""}`}>
        <button
          onClick={() => {
            handleClick();
          }}
        >
          <img
            src="/assets/images/comment_dots.svg"
            alt="comment_icon"
            style={{ marginRight: "6px" }}
          />
          {t("ask-expert")}
        </button>
      </div>
    </div>
  );
};

const WebinarTanyaAhli = ({name
  , setAskQuestion
  , setSpeaker
  , eventData
  , setOpenLogin
  , setAskExpert}) => {

  const [data, setData] = React.useState({});
  const { t } = useTranslation();
  React.useEffect(() => {
    if (!eventData || !eventData?.eventId) {
      return;
    }

    const currentDate = moment().format("YYYY-MM-DD");
    const currentWeekNumber = moment().lang("id-ID").weekday();

    getSchedule(eventData.eventId).then((d) => {
      const data = d?.data;

      let available = [];
      const unavailable = [];

      setAskExpert(data?.length > 0 ? "available" : "unavailable");

      data.map((d) => {
        const startTimes = d.startTime.split("::");

        startTimes.map((s) => {
          const parsedData = s.split(", ");
          const day = parsedData[0];

          parsedData.map((schedule, i) => {
            if (i === 0) {
              // day name
              return;
            }

            const time = schedule.split("-");
            const startTime =
              moment().lang("id-ID").day(day).format("YYYY-MM-DD") +
              " " +
              time[0];
            const endTime =
              moment().lang("id-ID").day(day).format("YYYY-MM-DD") +
              " " +
              time[1];

            const detailedSchedule = moment()
              .lang("id-ID")
              .hour(time[0].split(":")[0])
              .minute(time[0].split(":")[1])
              .day(day);

            let isAvailable = false;
            let scheduledTime =
              moment(startTime).format("HH:mm") +
              " - " +
              moment(endTime).format("HH:mm");

            if (moment().isBetween(moment(startTime), moment(endTime))) {
              isAvailable = true;
            }

            if (
              d?.exceptionalDate &&
              d?.exceptionalDate !== "" &&
              moment(d?.exceptionalDate).format("YYYY-MM-DD") === currentDate
            ) {
              isAvailable = false;
            }
            // comparedTime calculation
            let detailedScheduleDayNumber =
              moment(detailedSchedule).weekday() - currentWeekNumber;
            if (detailedScheduleDayNumber < 0) {
              detailedScheduleDayNumber = detailedScheduleDayNumber + 7;
            }

            // const comparedTime = detailedSchedule.diff(moment()) < 0 ? detailedSchedule.add(1, 'day').diff(moment()) : detailedSchedule.diff(moment());

            available.push({
              ...d,
              isAvailable,
              scheduledTime,
              scheduledDay: day,
              weekDay: detailedScheduleDayNumber,
              comparedTime:
                detailedScheduleDayNumber +
                Math.abs(detailedSchedule.diff(moment())),
              detailedScheduledTime: detailedSchedule,
            });
          });
        });
      });

      available = available.sort((a, b) => {
        return a.comparedTime - b.comparedTime;
      });

      setData({
        available,
        unavailable,
      });
    });
  }, [eventData]);

  if (data?.available?.length === 0 && data?.unavailable?.length === 0) {
    return <></>;
  }

  return (
    <div id="w_tanya_ahli">
      <h3>Halo{name ? ` ${name}.` : "."}</h3>
      <h3 style={{ fontWeight: 500 }}>{t("is-there")}</h3>
      <input
        name="question"
        placeholder={t("type-question")}
        onClick={() => {
          if (!name) {
            return setOpenLogin(true);
          }
          setAskQuestion(true);
        }}
      />
      <div className="wta_cards">
        {data?.available?.map((d, i) => {
          if (i > 1) {
            return;
          }

          return (
            <WebinarTanyaAhliCard
              key={i}
              isAvailable={d.isAvailable}
              photo={`https://fammi.ly/uploads/speakers/images/${d?.photo}`}
              name={d.speakerName}
              desc={d.speakerDesc}
              schedule={`${d.scheduledTime} WIB`}
              t={t}
              scheduledDay={d.scheduledDay}
              handleClick={() => {
                if (!name) {
                  return setOpenLogin(true);
                }

                if (!d.isAvailable) {
                  return;
                }

                setSpeaker({
                  speakerId: d?.speakerId,
                  speakerName: d?.speakerName,
                });
                setAskQuestion(true);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default WebinarTanyaAhli;
